module.exports = __webpack_public_path__ + "static/media/koipond.dabcd41c.jpeg";